import { translatedMessage } from "../service/LanguageService";

const ResultUtils = {

  getResultTypeByResult(result) {
    let type = translatedMessage('ResultType.' + result.type)

    if (result?.application?.competition?.type === "NATIONAL_PROMOVARE_ONLINE" && result.type === 'PRELIMINARY_TEST' &&
      result?.application?.competition?.positionCategory === 'FUNCTII_PUBLICE_DE_CONDUCERE_PROMOVARE') {
      type = translatedMessage('ResultType.' + result.type + '.PROMOVARE')
    }

    if (result?.application?.competition?.type === "NATIONAL_PROMOVARE_OFFLINE" &&
      (result.type === 'ADVANCED_TEST' || result.type === 'ADVANCED_TEST_FINAL') &&
      result?.application?.competition?.positionCategory === 'FUNCTII_PUBLICE_DE_CONDUCERE_PROMOVARE') {
      type = translatedMessage('ResultType.' + result.type + '.PROMOVARE')
    }

    return type;
  },

  getResultTypeByCompetitionAndResultType(competition, resultType) {
    let type = translatedMessage('ResultType.' + resultType)

    if (competition?.type === "NATIONAL_PROMOVARE_ONLINE" && resultType === 'PRELIMINARY_TEST' &&
      competition?.positionCategory === 'FUNCTII_PUBLICE_DE_CONDUCERE_PROMOVARE') {
      type = translatedMessage('ResultType.' + resultType + '.PROMOVARE')
    }

    if (competition?.type === "NATIONAL_PROMOVARE_OFFLINE" &&
      (resultType === 'ADVANCED_TEST' || resultType === 'ADVANCED_TEST_FINAL') &&
      competition?.positionCategory === 'FUNCTII_PUBLICE_DE_CONDUCERE_PROMOVARE') {
      type = translatedMessage('ResultType.' + resultType + '.PROMOVARE')
    }

    return type;
  },

  resultTypeTemplate(result) {
    return (
      <>{<span className={`status status-result-type-${result?.type.toString().toLowerCase()}`}>
        {this.getResultTypeByResult(result)}</span>
      }</>
    );
  },

  resultTypeTemplateByResultType(competition, resultType) {
    return (
      <>{<span className={`status status-result-type-${resultType.toString().toLowerCase()}`}>
        {this.getResultTypeByCompetitionAndResultType(competition, resultType)}</span>
      }</>
    );
  },

};

export default ResultUtils;